<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Tenant')" style="position: relative">
          <b-form
            @submit.prevent="onSubmitDetails"
            autocomplete="off"
            ref="cnt"
          >
            <div class="mb-2 position-relative">
              <div class="multiselect-lbl" v-if="details.company_id">
                {{ $t("Companies") }}
              </div>
              <multiselect
                v-model="details.company_id"
                :options="companyList"
                placeholder="Select a company"
                track-by="eid"
                label="name"
                :translate="false"
              ></multiselect>
            </div>
            <FloatingLabel
              v-model="details.brand_name"
              label="Brand Name"
              size="sm"
            />
            <FloatingLabel
              v-model="details.company_name"
              label="Company Name"
              size="sm"
            />
            <FloatingLabel v-model="details.cui" label="CUI" size="sm" />
            <FloatingLabel
              v-model="details.address"
              label="Address"
              type="textarea"
              size="sm"
            />
            <FloatingLabel
              v-model="details.bank_account"
              label="Bank Account"
              size="sm"
            />
            <FloatingLabel
              v-model="details.email_address"
              label="Email Address"
              size="sm"
            />
            <FloatingLabel
              v-model="details.phone_number"
              label="Phone Number"
              size="sm"
            />
            <FloatingLabel
              v-model="details.logo_path"
              label="Logo Path"
              size="sm"
            />
            <FloatingLabel
              v-model="details.ticket_footer_text"
              label="Ticket Footer Text"
              size="sm"
            />
            <FloatingLabel
              v-model="details.website"
              label="Website"
              size="sm"
            />

            <b-form-group
              :label="$t('Accept External Reserved Tickets')"
              class="grouping py-2 px-3 mb-3 mt-0"
            >
              <b-form-checkbox
                v-model="details.accept_external_reserved_tickets"
                :value="true"
                :unchecked-value="false"
                >{{ $t("Enable external reserved tickets") }}</b-form-checkbox
              >
            </b-form-group>

            <multiselect
              v-model="details.edefault_shop_id"
              :options="tenantShopsList"
              placeholder="No default shop selected"
              track-by="eid"
              label="name"
              :translate="false"
            ></multiselect>

            <div>&nbsp;</div>

            <FloatingLabel
              v-model="details.session_url"
              label="Session URL"
              type="textarea"
              size="sm"
            />

            <FloatingLabel
              v-model="details.bet_url"
              label="Bet URL"
              type="textarea"
              size="sm"
            />

            <FloatingLabel
              v-model="details.settle_url"
              label="Settle URL"
              type="textarea"
              size="sm"
            />

            <FloatingLabel
              v-model="details.details_url"
              label="Details URL"
              type="textarea"
              size="sm"
            />

            <FloatingLabel
              v-model="details.cancel_url"
              label="Cancel URL"
              type="textarea"
              size="sm"
            />

            <FloatingLabel
              v-model="details.bonus_settle_url"
              label="Bonus Settle URL"
              type="textarea"
              size="sm"
            />

            <FloatingLabel
              v-model="details.core_online_cash_ops_api_token"
              label="API Token"
              type="textarea"
              size="sm"
            />

            <div style="text-align: right">
              <b-button type="submit" variant="success">{{
                $t("Save")
              }}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FloatingLabel from "@/components/FloatingLabel";
import Multiselect from "@/components/multiselect-filters";
import { successConf, errorConf } from "@/shared/notifications";

export default {
  name: "tenant",
  props: ["selectedeid"],
  components: {
    FloatingLabel,
    Multiselect,
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }
    Promise.all([
      this.$store.dispatch("cache/fetch", "companies").catch((err) => {}),
      this.$store.dispatch("cache/fetch", "shops").catch((err) => {}),
    ]).finally(() => {
      if (this.eid != "0" && this.eid != "") {
        this.loadData();
      } else {
        this.newId = true;
      }
    });
  },
  data: function () {
    return {
      eid: "",
      details: {
        brand_name: "",
        company_name: "",
        cui: "",
        address: "",
        bank_account: "",
        email_address: "",
        phone_number: "",
        logo_path: "",
        ticket_footer_text: "",
        website: "",
        accept_external_reserved_tickets: false,
        company_id: null,
        edefault_shop_id: null,
        session_url: "",
        bet_url: "",
        settle_url: "",
        details_url: "",
        cancel_url: "",
        bonus_settle_url: "",
        core_online_cash_ops_api_token: "",
      },
      newId: false,
      temp: {},
    };
  },
  computed: {
    companyList() {
      return this.$store.getters["cache/companies"];
    },
    tenantShopsList() {
      let fulllist = this.$store.getters["cache/shops"];
      let temp = [];
      fulllist.forEach((element) => {
        if (element.etenant_id == this.eid) {
          temp.push(element);
        }
      });
      return temp;
    },
  },
  methods: {
    loadData() {
      if (this.eid == "") return;

      const loader = this.$loading.open({
        container: this.$refs.cnt,
      });

      this.$store
        .dispatch("tenant/read", this.eid)
        .then((resp) => {
          this.temp = resp.data;
          this.populateData(resp.data);
        })
        .catch((err) => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    onSubmitDetails() {
      const loader = this.$loading.open({
        container: this.$refs.cnt,
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "tenant/update";
      if (this.newId) {
        apiAction = "tenant/create";
      } else {
        detailsData.eid = this.eid;
      }

      if (detailsData.company_id) {
        detailsData.ecompany_id = detailsData.company_id.eid;
        delete detailsData.company_id;
      } else {
        detailsData.ecompany_id = "";
      }

      if (detailsData.edefault_shop_id && detailsData.edefault_shop_id.eid) {
        detailsData.edefault_shop_id = detailsData.edefault_shop_id.eid;
      } else {
        detailsData.edefault_shop_id = null;
      }

      this.$store
        .dispatch(apiAction, detailsData)
        .then((resp) => {
          let msg = "Tenant updated";
          if (this.newId && resp.data.id) {
            this.updateId(resp.data.id);
            msg = "Tenant created";
          }
          this.showSuccessNotification(msg);
        })
        .catch((err) => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";

      this.details.brand_name = r.brand_name;
      this.details.company_name = r.company_name;
      this.details.cui = r.cui;
      this.details.address = r.address;
      this.details.bank_account = r.bank_account;
      this.details.email_address = r.email_address;
      this.details.phone_number = r.phone_number;
      this.details.logo_path = r.logo_path;
      this.details.ticket_footer_text = r.ticket_footer_text;
      this.details.website = r.website;
      this.details.accept_external_reserved_tickets =
        r.accept_external_reserved_tickets;
      this.details.company_id = r.ecompany_id;
      if (this.details.company_id) {
        const cid = this.details.company_id;
        this.details.company_id = null;
        this.companyList.forEach((element) => {
          if (element.eid == cid) {
            this.details.company_id = element;
            return;
          }
        });
      }
      this.details.edefault_shop_id = r.edefault_shop_id;
      this.details.session_url = r.session_url;
      this.details.bet_url = r.bet_url;
      this.details.settle_url = r.settle_url;
      this.details.details_url = r.details_url;
      this.details.cancel_url = r.cancel_url;
      this.details.bonus_settle_url = r.bonus_settle_url;
      this.details.core_online_cash_ops_api_token =
        r.core_online_cash_ops_api_token;
      if (this.details.edefault_shop_id) {
        this.tenantShopsList.forEach((element) => {
          if (element.eid == this.details.edefault_shop_id) {
            this.details.edefault_shop_id = element;
            return;
          }
        });
      }
    },
    updateId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "Tenant", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
